export enum ShippingResource {
  Invoices = 'invoices',
  InvoiceOrders = 'invoice-orders',
  Orders = 'orders',
  AmazonOrders = 'amazon-orders',
  Shipments = 'shipments'
}
